import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {

  connectedCallback() {
    console.log('[CartDrawer] connectedCallback');
    super.connectedCallback();

    // Listen to all real cart events
    const events = [
      'cart:update',
      'cart:item-added',
      'cart:add',
      CartAddEvent.eventName
    ];

    events.forEach(evt => {
      document.addEventListener(evt, this.#handleCartAdd);
      console.log(`[CartDrawer] Listening for: ${evt}`);
    });

    this._eventsListened = events;
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    if (this._eventsListened) {
      this._eventsListened.forEach(evt =>
        document.removeEventListener(evt, this.#handleCartAdd)
      );
    }
  }

  #handleCartAdd = async (event) => {
    console.log('[CartDrawer] EVENT FIRED →', event.type);

    let cart;
    try {
      cart = await fetch('/cart.js').then(r => r.json());
    } catch (err) {
      console.error('[CartDrawer] Failed to fetch cart.js', err);
      return;
    }

    console.log('[CartDrawer] cart.item_count:', cart.item_count);

    // Only open drawer when 0 → 1 items
    if (cart.item_count <= 1) {
      console.log('[CartDrawer] Opening drawer (cart has 0 or 1 items)');
      this.showDialog();
      return;
    }

    console.log('[CartDrawer] Drawer NOT opened (cart has > 1 item)');
  };

  open() {
    console.log('[CartDrawer] open()');
    this.showDialog();
  }

  close() {
    console.log('[CartDrawer] close()');
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}